"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import { clamp } from '../Slider/utils.common.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { wrapper, bar } from './styles.js';

var _excluded = ["value", "width", "color", "ariaLabel", "ariaLabelledby", "id"];
var LinearProgress = function LinearProgress(_ref) {
  var value = _ref.value,
    _ref$width = _ref.width,
    width = _ref$width === undefined ? '100%' : _ref$width,
    color = _ref.color,
    ariaLabel = _ref.ariaLabel,
    ariaLabelledby = _ref.ariaLabelledby,
    id = _ref.id,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  value = clamp(value, 0, 100);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(wrapper, _extends({
    width: width,
    "data-testid": "elemental-LinearProgress-".concat(id || value),
    id: id,
    role: "progressbar",
    tabIndex: 0,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-valuemax": 100,
    "aria-valuemin": 0,
    "aria-valuenow": value
  }, props), /*#__PURE__*/React.createElement(bar, {
    color: theme.linearProgress.web.bar.inactiveColor,
    style: {
      width: '100%'
    }
  }), /*#__PURE__*/React.createElement(bar, {
    color: color || theme.linearProgress.web.color,
    style: {
      width: value + '%'
    }
  })));
};

export { LinearProgress };
